import React, { useContext } from "react";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";
import { OverviewContext } from "../overview/context/OverviewContext";
import { FormattedMessage, injectIntl } from "react-intl";
import Row from "@amzn/meridian/row";
import Tooltip from "@amzn/meridian/tooltip";
import Box from "@amzn/meridian/box";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import Icon from "@amzn/meridian/icon";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import { getETA } from "../overview/utils/utils";
import {
  INDUCT,
  STOW,
  NOT_AVAILABLE,
  COLON,
} from "../overview/utils/PPAConstants";

const ETAView = (props) => {
  const { cycles } = useContext(CycleFilterContext);
  const { viewModel } = useContext(OverviewContext);
  const { pvaData } = useContext(PVAOverviewContext);

  const getExpectedRollover = () => {
    if (
      !pvaData.dynamicShiftPlans.latest ||
      !pvaData.dynamicShiftPlans.latest.output
    ) {
      return NOT_AVAILABLE;
    }
    const warnings = pvaData.dynamicShiftPlans.latest.output.warnings;
    if (warnings == null) {
      return 0;
    }
    return Object.values(warnings)[0];
  };

  const getETAValue = (pvaData, cycles, processName) => {
    const etaTime = getETA(pvaData, cycles, processName);
    if (etaTime) {
      return (
        ("0" + etaTime.getHours()).slice(-2) +
        COLON +
        ("0" + etaTime.getMinutes()).slice(-2)
      );
    }
    return NOT_AVAILABLE;
  };

  return (
    <Box type="outline" spacingInset="400">
      <div>
        <div className="overview-fph">
          <Heading level={2} type="h300" alignment="left">
            <FormattedMessage
              id={viewModel.eta[props.eta.processName].title}
              defaultMessage={
                viewModel.eta[props.eta.processName].defaultMessage
              }
            />
            <Tooltip
              position="right"
              title={props.intl.formatMessage({
                id: viewModel.eta[props.eta.processName].tooltip,
                defaultMessage:
                  viewModel.eta[props.eta.processName].tooltipMessage,
              })}
            >
              <Icon className={"custom-tool-tip"} tokens={infoKnockoutTokens} />
            </Tooltip>
          </Heading>
        </div>
        <Row width="100%" widths={["grid-4", "grid-4", "grid-4"]}>
          <div>
            <Text type="b100">
              <FormattedMessage
                id="package_overview.sort_induct"
                defaultMessage="Induct"
              />
            </Text>
            <Text type="d50">{getETAValue(pvaData, cycles, INDUCT)}</Text>
          </div>
          <div>
            <Text type="b100">
              <FormattedMessage
                id="package_overview.sort_stow"
                defaultMessage="Stow"
              />
            </Text>
            <Text type="d50">{getETAValue(pvaData, cycles, STOW)}</Text>
          </div>
          <div>
            <Text type="b100">
              <FormattedMessage
                id="eta.rollover"
                defaultMessage="Expected rollover"
              />
            </Text>
            <Text type="d50">{getExpectedRollover()}</Text>
          </div>
        </Row>
      </div>
    </Box>
  );
};

export default injectIntl(ETAView);



// WEBPACK FOOTER //
// ./src/components/WIP/ETAView.js